import { Component } from '@angular/core';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { ModalComponent } from '../../../../../models/modal-component';
import { AssetPipe } from '../../../../../pipes/asset.pipe';
import { AccessService } from '../../../../../services/access.service';
import { RouteService } from '../../../../../services/route.service';
import { environment } from '../../../../../../environments/environment';

@Component({
    selector: 'app-buy-book-modal',
    templateUrl: './buy-book-modal.component.html',
    styleUrls: ['./buy-book-modal.component.scss'],
    imports: [
        AssetPipe
    ],
    standalone: true
})
export class BuyBookModalComponent extends ModalComponent {
    static MODAL_ID = 'buyBookModal';

    readonly window = window;

    constructor(
        public applicationStateService: ApplicationStateService,
        public accessService: AccessService,
        private routeService: RouteService
    ) {
        super();
    }

    getUpgradeRoute(code: string): string {
        return this.routeService.getAbsoluteRoute(environment.endpointUrls.codeUpgrade, {code});
    }

    getId(): string {
        return BuyBookModalComponent.MODAL_ID;
    }
}
